import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Instructor } from '@modules/instructor/models/instructor';
import { isSameDay, parseISO } from 'date-fns';
import { TRANSLATION_SCOPE } from '../../i18n/scope';
import { AvailableSchedule, ClassroomCourse } from '../../models/classroom-course';
import { ClassroomScheduleModalComponent } from '../classroom-schedules-modal/classroom-schedules-modal.component';
import { filter } from "rxjs/operators";

@Component({
  selector: 'app-classroom-schedules',
  templateUrl: './classroom-schedules.component.html',
  styleUrls: ['./classroom-schedules.component.scss'],
})
export class ClassroomScheduleComponent implements OnInit, OnChanges {
  @Input() schedules: AvailableSchedule[] = [];
  @Input() multipleParticipant: boolean = false;
  @Input() numberOfParticipant:  number = 0;
  @Input() classroom: ClassroomCourse;
  @Input() instructor: Instructor;

  @Output() onSelectedSchedule = new EventEmitter();

  selectedScheduleId = 0;
  selectedScheduleTimeId = 0;
  dateSlideIndex = 1;
  timeSlideIndex = 1;
  scheduleDateGroups: any[] = [];
  scheduleTimeGroups: any[] = [];

  selectedSchedule = null;

  translationScope = TRANSLATION_SCOPE;

  constructor(
    private matDialog: MatDialog,
  ) {}

  ngOnInit() {}

  ngOnChanges(): void {
    this.paginateScheduleDate();
  }

  selectedScheduleDate(schedule?: AvailableSchedule) {
    this.selectedScheduleId = schedule.id;
    this.selectedScheduleTimeId = 0;
    this.timeSlideIndex = 1;
    this.onSelectedSchedule.emit(null);
    this.paginateScheduleTime(schedule);
    this.openScheduleModal();
  }

  showMoreSchedules() {
    this.selectedSchedule = null;
    this.selectedScheduleId = null;
    this.onSelectedSchedule.emit(null);
    this.openScheduleModal();
  }

  selectedScheduleTime(schedule: AvailableSchedule) {
    this.selectedScheduleTimeId = schedule.id;
    this.onSelectedSchedule.emit(schedule);
  }

  previousDateGroup() {
    if (this.dateSlideIndex > 1) this.dateSlideIndex -= 1;
  }

  nextDateGroup() {
    if (this.dateSlideIndex < this.scheduleDateGroups.length) this.dateSlideIndex += 1;
  }

  previousTimeGroup() {
    if (this.timeSlideIndex > 1) this.timeSlideIndex -= 1;
  }

  nextTimeGroup() {
    if (this.timeSlideIndex < this.scheduleTimeGroups.length) this.timeSlideIndex += 1;
  }

  paginateScheduleDate() {
    const uniqueSchedules = this.schedules.reduce((acc, current) => {
      const x = acc.find((item) => isSameDay(parseISO(item.startDate), parseISO(current.startDate)));
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);

    // group schedules by 9 items
    this.scheduleDateGroups = uniqueSchedules.reduce((acc, curr, i) => {
      if (!(i % 9)) {
        acc.push(uniqueSchedules.slice(i, i + 9));
      }
      return acc;
    }, []);
  }

  paginateScheduleTime(schedule: AvailableSchedule) {
    const schedulesTimes = this.schedules.filter((item) =>
      isSameDay(parseISO(item.startDate), parseISO(schedule.startDate))
    );

    this.scheduleTimeGroups = schedulesTimes.reduce((acc, curr, i) => {
      if (!(i % 3)) {
        acc.push(schedulesTimes.slice(i, i + 3));
      }
      return acc;
    }, []);
  }

  private openScheduleModal(): void {
    this.matDialog.open(ClassroomScheduleModalComponent, {
      data: {
        schedules: this.schedules,
        selectedScheduleId:  this.selectedScheduleId,
        classroom: this.classroom,
        instructor: this.instructor
      },
      disableClose: true,
      panelClass: 'classroom-schedules-modal',
    }).afterClosed().pipe(filter(({closeWithoutBuying}) => Boolean(closeWithoutBuying))).subscribe(() => {
      this.selectedScheduleId = null;
    });
  }
}
